'use strict';

(function () {
  'use strict';

  angular.module('msTracker').component('confirmButton', {
    bindings: {
      itemId: '=',
      deleteAction: '&'
    },
    templateUrl: 'tracker/templates/confirm-button.html',
    controller: ConfirmButtonCtrl
  });

  ConfirmButtonCtrl.$inject = ['$log', 'focus'];

  function ConfirmButtonCtrl($log, focus) {
    var vm = this;
    vm.$onInit = init;
    vm.confirmAction = confirmAction;

    function init() {
      vm.confirmState = false;
    }

    function confirmAction() {
      if (vm.deleteAction) {
        vm.deleteAction();
      } else {
        $log.warn('No confirm action defined in ConfirmButtonCtrl');
      }
    }

    vm.focusConfirmBtn = function () {
      vm.confirmState = true;
      focus.byId(vm.itemId);
    };
  }
})();